import { getThemeIdFromParameter } from '../utils/optionalArgumentHelpers';
import { isTeamsThemeId } from 'owa-teams-theme-utils';

export default function getIsCurrentThemeCalendarTeamsTheme(themeId?: string) {
    themeId = getThemeIdFromParameter(themeId);

    return isTeamsThemeId(themeId);
}
